import { connect } from 'react-redux';
import { tickerSet } from '../actions';

const mapDispatchToProps = (dispatch) => ({
  tickerSet: (data) => {
    dispatch(tickerSet(data));
  }
});

const mapStateToProps = (state) => ({
  ticker: state.ticker 
});

export default connect(mapStateToProps, mapDispatchToProps);
